export const contactSelector = (state) => (state.contact);
export const schemaSelector = (state) => (state.schema);
